'use strict';

import keymirror from 'keymirror';

export default keymirror({
    NUTRITION_PATTERN_LOAD: null,
    NUTRITION_PATTERN_RELOAD: null,
});
